import React from 'react'
import { connect } from 'react-redux'

import {
  trackPromotionalModalToSignup,
  trackPromotionalModalToLearnMore,
} from 'data/analytics/actions'

import ModalBody from 'components/Utils/Modal/Body'
import ModalWrapper from 'components/Utils/Modal/Wrapper'
import { Button, Text } from 'components/base'
import { CloseIcon } from 'components/Utils/Icons'

import illustrationSrc from 'assets/images/illustrations/promotional-modal.svg'

export class PromotionalModal extends React.Component {
  state = {
    isOpen: false,
  }

  componentWillMount() {
    this.timeout = setTimeout(() => {
      this.setState({ isOpen: true })
    }, 5000)
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  render() {
    const {
      origin,
      trackPromotionalModalToSignup,
      trackPromotionalModalToLearnMore,
    } = this.props
    return (
      <ModalWrapper
        portalClassName="promotional-modal"
        onRequestClose={() => this.setState({ isOpen: false })}
        size={560}
        center
        isOpen={this.state.isOpen}
      >
        <ModalBody className="position-relative" style={{ padding: 0 }}>
          <div
            className="shade-30 shade-20-on-hover pointer padding-smaller zindex-small"
            style={{ position: 'absolute', right: 24, top: 24 }}
            onClick={() => {
              this.setState({ isOpen: false })
            }}
          >
            <CloseIcon size={16} />
          </div>
          <div
            className="position-relative padding-huge"
            style={{ paddingBottom: 120 }}
          >
            <div className="position-relative zindex-small">
              <div
                className="font-family-title font-weight-normal margin-bottom-normal"
                style={{ fontSize: '32px', lineHeight: '1.3em' }}
              >
                Get on Slite - it's free!
              </div>
              <Text.EditorCorpus className="margin-bottom-larger line-height-larger">
                Slite makes all your team information centralized and organized.
                <br />
                <br />
                Document your team efforts, create your wiki, take meeting notes
                or track projects in a simple way.
              </Text.EditorCorpus>

              <div className="flexbox margin-bottom-normal">
                <Button.Primary
                  onClick={() => {
                    trackPromotionalModalToSignup()
                    window.open(
                      `https://slite.com/organization/create?utm_source=public-share-${origin}&utm_medium=modal&utm_campaign=cta-signup`,
                      '_blank'
                    )
                  }}
                  className="margin-right-normal"
                >
                  Start for free
                </Button.Primary>
                <Button.Secondary
                  onClick={() => {
                    trackPromotionalModalToLearnMore()
                    window.open(
                      `https://slite.com/organization/create?utm_source=public-share-${origin}&utm_medium=modal&utm_campaign=cta-signup`,
                      '_blank'
                    )
                  }}
                  href={`https://slite.com?utm_source=public-share-${origin}&utm_medium=modal&utm_campaign=cta-learn-more`}
                  target="_blank"
                >
                  Learn more
                </Button.Secondary>
              </div>
              <Text.Detail className="font-size-normal">
                Already have an account?{' '}
                <Text.Action
                  inline
                  className="underline"
                  href="https://slite.com/organization/select"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Log in
                </Text.Action>
              </Text.Detail>
            </div>
            <img
              alt="illu"
              src={illustrationSrc}
              className="position-absolute zindex-null"
              style={{ bottom: 0, left: 0, width: '100%' }}
            />
          </div>
        </ModalBody>
      </ModalWrapper>
    )
  }
}

export default connect(
  null,
  { trackPromotionalModalToSignup, trackPromotionalModalToLearnMore }
)(PromotionalModal)
